import { render, staticRenderFns } from "./CategoriasMantenimiento.vue?vue&type=template&id=5d2a5352&"
import script from "./CategoriasMantenimiento.vue?vue&type=script&lang=js&"
export * from "./CategoriasMantenimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports